import { combineReducers } from 'redux';

import {
    SET_EMAIL_ACTION,
    CLEAR_EMAIL_ACTION,
    EXISTING_ACCOUNT_CHECK,
    SHOW_CAPTCHA,
    HIDE_CAPTCHA,
    SET_ACCOUNT_EXISTENT,
    SHOW_AUTH_NOTIFICATION,
    CLEAR_AUTH_NOTIFICATION,
    SHOW_LINKED_ACCOUNTS_DIALOG,
    FORCE_STLD,
    UPDATE_CURRENT_FORM_TYPE_ACTION,
    EXISTING_SOFT_ACCOUNT_CHECK,
} from '../actions/auth';
import { SET_SEND_EMAIL_LINK_ACCOUNT } from '../actions/email';
import { STLD_ENABLED } from '../constants';

// TODO: add else statement account is not existent
const isAccountExistent = (state = false, action) => {
    let nextState = state;

    if (action.type === SET_ACCOUNT_EXISTENT) {
        nextState = true;
    }

    return nextState;
};

const referrer = (state = '', action) => {
    const nextState = state;

    if (global.window && window.localStorage && nextState) {
        localStorage.setItem('referrer', nextState);
    }

    return nextState;
};

const stld = (state = '', action) => {
    let nextState = state;

    if (action.type === FORCE_STLD) {
        nextState = STLD_ENABLED;
    }

    return nextState;
};

const email = (state = '', action) => {
    let nextState = state;

    if (
        action.type === SET_EMAIL_ACTION ||
        action.type === SET_ACCOUNT_EXISTENT
    ) {
        nextState = action.payload;
    } else if (action.type === CLEAR_EMAIL_ACTION) {
        nextState = '';
    }

    return nextState;
};

const displayCaptcha = (state = false, action) => {
    let nextState = state;

    if (action.type === SHOW_CAPTCHA) {
        nextState = true;
    } else if (action.type === HIDE_CAPTCHA) {
        nextState = false;
    }

    return nextState;
};

const authNotificationOptions = (state = {}, { type, payload }) => {
    let nextState = state;

    if (type === SHOW_AUTH_NOTIFICATION) {
        nextState = payload;
    } else if (type === CLEAR_AUTH_NOTIFICATION) {
        nextState = {};
    }

    return nextState;
};

const linkedAccountSuccessUrl = (state = '', { type, payload }) => {
    let nextState = state;

    if (type === SHOW_LINKED_ACCOUNTS_DIALOG) {
        nextState = payload.redirectUrl;
    }

    return nextState;
};

export const userHasAccount = (state = false, { type, payload }) => {
    let nextState = state;

    if (type === EXISTING_ACCOUNT_CHECK) {
        nextState = payload.userHasAccount;
    }

    return nextState;
};

export const userHasSoftAccount = (state = false, { type, payload }) => {
    let nextState = state;

    if (type === EXISTING_SOFT_ACCOUNT_CHECK) {
        nextState = payload.userHasSoftAccount;
    }

    return nextState;
};

export const currentFormType = (state = '', { type, payload }) => {
    let nextState = state;
    if (type === UPDATE_CURRENT_FORM_TYPE_ACTION) {
        nextState = payload.formType;
    }

    return nextState;
};

const emailLinkAccount = (state = false, { type, payload }) => {
    let nextState = state;

    if (type === SET_SEND_EMAIL_LINK_ACCOUNT) {
        nextState = payload;
    }
    return nextState;
};

export default combineReducers({
    currentFormType,
    referrer,
    userTypeParams: (state = {}) => state,
    forward: (state = '') => state,
    email,
    locale: (state = '') => state,
    isAuthenticated: (state = false) => state,
    recaptcha2PublicKey: (state = '') => state,
    recaptcha3PublicKey: (state = '') => state,
    displayCaptcha,
    fp: (state = false) => state,
    pckg: (state = '') => state,
    stld,
    isAccountExistent,
    authNotificationOptions,
    linkedAccountSuccessUrl,
    userHasAccount,
    userHasSoftAccount,
    disableRecaptcha3: (state = false) => state,
    featureFlags: (state = {}) => state,
    emailLinkAccount,
    referral_validation_response: (state = {}) => state,
});
